import {
  TaskDomainSchema,
  TaskPrioritySchema,
  TaskStatusSchema,
  TaskSubtypeSchema,
} from "@redotech/redo-task-common/task";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

const taskAssigneeSchema_ = z.object({
  legacyUserId: z.string(),
  name: z.string().nullable(),
});
export const taskAssigneeSchema: z.ZodType<TaskAssignee> = taskAssigneeSchema_;
export interface TaskAssignee extends z.infer<typeof taskAssigneeSchema_> {}

const taskRowSchema_ = z.object({
  id: z.string(),
  subtype: TaskSubtypeSchema,
  priority: TaskPrioritySchema,
  status: TaskStatusSchema,
  createdAt: z.date(),
  completedAt: z.date().nullable(),
  /** Set on `unfulfillable_item` tasks. */
  productId: z.string().nullable(),
  productTitle: z.string().nullable(),
  /** Set on `undeclared_item` tasks; MongoDB ObjectId hex of the source return. */
  returnId: z.string().nullable(),
  assignees: z.array(taskAssigneeSchema),
});
export const taskRowSchema: z.ZodType<TaskRow> = taskRowSchema_;
export interface TaskRow extends z.infer<typeof taskRowSchema_> {}

export const getTasks = unaryRpc({
  name: "getTasks" as const,
  input: z.object({
    domain: TaskDomainSchema.optional(),
    statuses: z.array(TaskStatusSchema).optional(),
    subtypes: z.array(TaskSubtypeSchema).optional(),
    priorities: z.array(TaskPrioritySchema).optional(),
    page: z.number().min(0).optional(),
    pageSize: z.number().min(1).max(200).default(25),
  }),
  output: z.object({
    tasks: z.array(taskRowSchema),
    totalCount: z.number(),
    page: z.number(),
    pageSize: z.number(),
  }),
});
